function buildMenu (allowed) {
  let menu = []
  if (allowed == null || allowed.includes('Visitors'))  {
    menu = [
    {
      title: 'Visitors',
      icon: 'mdi-account-multiple-outline',
      items: [
        {
          title: 'Visitor Log', 
          icon: 'mdi-bookshelf',
          path: '/VisLog'}
      ]
    }
  ] 
} 
  
  return menu
}

export default buildMenu